<template>
    <kgr-multi-select
        display="name"
        :value="selection"
        :options="clubFees"
        :loading="loading"
        :label="$t('clubFee')"
        searchable
        :remove-selected="true"
        :show-options="true"
        @post-input="updateSelection($event)"
    />
</template>

<script>
import ClubFeeRepository from '../../../../js/repository/ClubFeeRepository.js';
import MultiSelect from './MultiSelect.vue';

export default {
    components: {
        'kgr-multi-select': MultiSelect,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        value: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            clubFees: [],
            selection: [],
        };
    },
    created() {
        this.load();
        this.selection = this.value;
    },
    methods: {
        load() {
            ClubFeeRepository.findByClubIdExcludeArchivedAndSalesList(this.clubId)
                .then((data) => this.clubFees = data)
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.loading = false);
        },
        updateSelection(value) {
            this.selection = value;
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    },
};
</script>
